import React, { useEffect } from 'react';
import { get as getLatestTeamId } from '../utils/latest-team-id';
import { paths, fillPlaceholders, useNavigate } from '../routing';
import { useAuth } from '../auth';
import LoadingSpinner from '../components/loading-spinner';
interface LandingPageProps {
  token?: string;
}

const Landing = ({ token }: LandingPageProps) => {
  const [{ authLoading, queryLoading, loggedIn, user }] = useAuth();
  const navigate = useNavigate();
  const loading = authLoading || queryLoading;

  useEffect(() => {
    if (!loading && !loggedIn) {
      return navigate(paths.auth.login);
    }
  }, [loading, loggedIn, navigate]);

  useEffect(() => {
    if (loading || !loggedIn) {
      return;
    }

    // Wait for allTeams to be loaded before making routing decisions
    // This prevents premature navigation to no-team page when logging in as user
    if (!user || user.allTeams === undefined) {
      return;
    }

    const goToTeamDeals = (id: string) => {
      const urlToNavigate = token
        ? fillPlaceholders(paths.deals.landingWithToken, { teamId: id, dealToken: token })
        : fillPlaceholders(paths.deals.landing, { teamId: id });

      navigate(urlToNavigate);
    };

    const latestTeamId = getLatestTeamId(user?.id);
    const userTeams = user?.allTeams || [];

    if (latestTeamId && userTeams.some(({ id }: { id: string }) => id === latestTeamId)) {
      goToTeamDeals(latestTeamId);
    } else if (userTeams.length) {
      goToTeamDeals(userTeams[0].id);
    } else {
      navigate(paths.noTeam);
    }
  }, [loading, loggedIn, user, navigate, token]);

  // Show loading spinner while auth is loading or while waiting for user data to fully load
  if (loading || (loggedIn && (!user || user.allTeams === undefined))) {
    return <LoadingSpinner />;
  }

  return null;
};

export default Landing;
